import { lazy } from 'react';

export const AsyncOfferPageContainer = lazy(() => import(
  /* webpackChunkName: 'offer_page' */
  './OfferPageContainer'
));
